import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import request from '../../../app/api/requests';
import {Link, useNavigate} from 'react-router-dom';
import {ReactComponent as CloseBtn} from '../../../shared/lib/icons/svg/menu_ic/close_ofcanvas.svg';
import {ReactComponent as TemplateIcon} from '../../../features/select-repeat-template/lib/icons/repeatTemplate_icon.svg';
import {ReactComponent as TemplateTaskIcon} from '../lib/icons/task-template-icon-small.svg';
import DonationBtn from '../../../shared/ui/DonationBtn/DonationBtn';
import { endSession } from '../../../shared/lib/auth/session';
import { useDispatch } from 'react-redux';
import { UserAuthActionTypes } from '../../../features/user/userStore';
import { ProjectSupportComponent } from '../../../features/project-support';
import './user-menu-mobile.css';
import { DEFAULT_AVATAR_URL, handleAvatarLoadError } from '../../../shared/lib/avatarFallback';


export function UserMenuMobile({active, setActive, avatar}) {
    const closeMenu = () => setActive(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false)

    function Logout() {
        endSession();
        setActive(false)
        dispatch({type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT})
        navigate('/login', {require: true});
    }

    useEffect(() => {
        request.get('/Account/User/', {
            params: {UserId: localStorage.getItem('userID') }
        })
        .then(response =>{
            localStorage.setItem('firstName', response.data.name === null ? '' : response.data.name);
            localStorage.setItem('lastName', response.data.lastname === null ? '' : response.data.lastname);
            localStorage.setItem('position', response.data.position === null ? '' : response.data.position)
        })
    }, [])

    return (
        <>
            {
                modalShow && 
                <ProjectSupportComponent modal={modalShow} setModal={setModalShow}/>
            }
            <Offcanvas id='user-menu-mobile' className='user-menu-mobile' aria-label='Меню пользователя' show={active} onHide={closeMenu} placement='end' style={{width: '264px', padding: '12px 22px',  borderRadius: '10px 0px 0px 10px', backgroundColor: '#232360', opacity: '0.95'}}>
                <Offcanvas.Header  closeVariant='white' style={{padding: '0'}}>
                    <Offcanvas.Title style={{width: '100%', display:'flex', alignItems: 'center'}}>
                        <img className='user-avatar-mobile' src={avatar || DEFAULT_AVATAR_URL} onError={handleAvatarLoadError} alt=''/>
                        <div className='a-list-menu__person-info'>
                            <div className='a-list-menu__person-name'>
                                <p>{localStorage.getItem('firstName')}</p>
                                <p>{localStorage.getItem('lastName')}</p>
                            </div>
                            <div className='a-list-menu__person-post'>
                                <p>{localStorage.getItem('position')}</p>
                            </div>
                        </div>
                        <button type='button' className='user-menu-mobile__close' aria-label='Закрыть меню' onClick={closeMenu}>
                            <CloseBtn style={{stroke: '#FFF'}} />
                        </button>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{padding: '0'}}>
                <ul className='a-list-menu'>
                        <li className='a-item-menu__mobile'>
                            <Link to="/profile" className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-1'/>
                                Профиль
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/statistics' className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-2'/>
                                Статистика
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/settings' className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-3'/>
                                Настройки
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/completed' className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-4'/>
                                Выполненные
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/removed_todo' className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-5'/>
                                Корзина
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/tags' className='a-menu__mobile' onClick={closeMenu}>
                                <span className='bg_menu-6'/>
                                Метки
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/automation' className='a-menu__mobile' onClick={closeMenu}>
                                <TemplateIcon aria-hidden='true' style={{fill: '#FFF'}}/>
                                Автоматизация
                            </Link>
                        </li>
                        <li className='a-item-menu__mobile'>
                            <Link to='/templates' className='a-menu__mobile' onClick={closeMenu}>
                                <TemplateTaskIcon aria-hidden='true' style={{fill: '#FFF'}} />
                                Шаблоны задач
                            </Link>
                        </li>
                        {/* <li className='a-item-menu__mobile'>
                            <span className='bg_menu-7'/>
                            <span className='a-menu__mobile' href="#">Премиум</span>
                        </li> */}
                        <li className="a-item-menu__mobile">
                            <button type="button" className="a-menu__mobile" onClick={Logout}>
                                <span className="bg_menu-8" aria-hidden="true" />
                                Выйти
                            </button>
                        </li>
                    </ul>
                    <div style={{display: 'flex', justifyContent:'center'}} onClick={() => setActive(false)}>
                        <DonationBtn 
                            updateModal={setModalShow} 
                            title='Поддержать проект'/>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}
